<div class="empDiv">
    <header class="info-tile-alt heading-row">
        <div tooltip="{{drawerName}}" offset="0" zIndex="20000" placement="bottom" class="title-container">
            <h2>{{drawerName}}</h2>
        </div>
        <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()">
            <i class="fas fa-times" aria-hidden="true"></i>
        </div>
    </header>
    <section class="sideRight-body">
        <table class="assign-activities-checklist" cellpadding="5" cellspacing="5">
            <tr *ngIf="employeeList && employeeList.length!==0">
                <td>
                    <label class="employeeCount">
                        <span *ngIf="employeeList.length === 1">{{employeeList.length}} EMPLOYEE</span>
                        <span *ngIf="employeeList.length > 1">{{employeeList.length}} EMPLOYEES</span>
                    </label>
                </td>
            </tr>
            <tr *ngFor="let emp of employeeList">
                <td>
                    <label class="empFont">
                        <span>
                            {{emp.name}} ({{emp.taxPeriod}})
                        </span>
                    </label>
                </td>
            </tr>
        </table>
    </section>
    <footer class="endFormSubmit info-tile">
        <button type='button' class="btn kpmg-button--flat"
                (click)="rightSideDrawerService.closeRightSideDrawer()">
            Cancel
        </button>
    </footer>
</div>
